import { IObservable } from '~/rage/utils';
import { DialogueReplyIcon } from '~/shared';

export interface IDialogueState {
	title: string;
	text: string;
	replies: IDialogueReplyData[];
	rewards?: IDialogueRewardData[];
}

export interface IDialogueReplyData {
	id: string;
	text: string;
	icon: DialogueReplyIcon;
}

export enum DialogueReward {
	Exp = 'exp',
	Money = 'money',
}

export interface IDialogueRewardData {
	type: DialogueReward; // @TODO Универсальные реварды
	amount: number;
}

export type IActionCallback = (
	...params: (string | undefined)[]
) => void | Promise<void>;

export interface IDialogueService {
	/**
	 * Подписываемся на выбор реплик с привязанным к ним событиям
	 */
	onAction(name: string, cb: IActionCallback): void;

	/**
	 * Получение текущего состояния диалога
	 */
	getDialogueState(): IObservable<IDialogueState | null>;

	/**
	 * Выбрать вариант ответа в диалоге
	 */
	selectReply(replyId: string): Promise<void>;
}
